import { DefaultSuggestion } from '../../../contracts';

export type BodyStyle = DefaultSuggestion & {
  image: string;
};

const defaultBodyStyles: BodyStyle[] = [
  {
    text: 'SUVs',
    image: `/home-assets/nba/suv.png?width=150`,
    filters: { bodyStyles: ['Suv'] }
  },
  {
    text: 'Sedans',
    image: `/home-assets/nba/sedan.png?width=150`,
    filters: { bodyStyles: ['Sedan'] }
  },
  {
    text: 'Trucks',
    image: `/home-assets/nba/truck.png?width=150`,
    filters: { bodyStyles: ['Pickup'] }
  },
  {
    text: 'Coupes',
    image: `/home-assets/nba/coupe.png?width=150`,
    filters: { bodyStyles: ['Coupe'] }
  },
  {
    text: 'Minivans',
    image: `/home-assets/nba/minivan.png?width=150`,
    filters: { bodyStyles: ['MiniVan'] }
  },
  {
    text: 'Convertibles',
    image: `/home-assets/nba/convertible.png?width=150`,
    filters: { bodyStyles: ['Convertible'] }
  },
  {
    text: 'Wagons',
    image: `/home-assets/nba/wagon.png?width=150`,
    filters: { bodyStyles: ['Wagon'] }
  },
  {
    text: 'Hatchbacks',
    image: `/home-assets/nba/hatchback.png?width=150`,
    filters: { bodyStyles: ['Hatchback'] }
  },
  {
    text: 'Electrics',
    image: `/home-assets/nba/electric.png?width=150`,
    filters: { fuelTypes: ['Electric'] }
  },
  {
    text: 'Hybrids',
    image: `/home-assets/nba/hybrid.png?width=150`,
    filters: { fuelTypes: ['Hybrid'] }
  },
  {
    text: 'Plug-in Hybrids',
    image: `/home-assets/nba/plug-in-hybrid.png?width=150`,
    filters: { fuelTypes: ['Plug-In Hybrid'] }
  },
  {
    text: 'View all',
    image: `/merch-assets/icons/view-all.svg`,
    filters: {}
  }
];

export default defaultBodyStyles;
